var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugins",style:({'padding':_vm.plugins_data.style.margin/2+'px 0'})},[_c('div',{staticClass:"guide",style:({'border-bottom-width':_vm.plugins_data.style.height/2+'px','border-bottom-style':_vm.plugins_data.config.style,'border-bottom-color':_vm.plugins_data.style.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }